import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './redux/rootReducer'
import { uMUserApi } from './redux/Api/UserManagment/uMUserApiSlice'
import { uMUsersApi } from './redux/Api/UserManagment/uMUsersApiSlice'
import { uMGroupPermissionsApi } from './redux/Api/UserManagment/uMGroupPermissionsApiSlice'
import { uMGroupsApi } from './redux/Api/UserManagment/uMGroupsApiSlice'
import { uMPermissionsApi } from './redux/Api/UserManagment/uMPermissionsApiSlice'
import { uMUserGroupsApi } from './redux/Api/UserManagment/uMUserGroupsApiSlice'
import { uMUserPermissionsApi } from './redux/Api/UserManagment/uMUserPermissionsApiSlice'
import { uMUsersContentTypesApi } from './redux/Api/UserManagment/uMUsersContentTypesApiSlice'
import { cMCampaignsApi } from './redux/Api/CampaignManagment/cMCampaignsApiSlice'
import { cMLanguagesApi } from './redux/Api/CampaignManagment/cMLanguagesApiSlice'
import { cMLoaApi } from './redux/Api/CampaignManagment/cMLoaApiSlice'
import { cMPlatformsApi } from './redux/Api/CampaignManagment/cMPlatformsApiSlice'
import { cMTypesApi } from './redux/Api/CampaignManagment/cMTypesApiSlice'
import { customerCampaignPlatformApi } from './redux/Api/CampaignManagment/cMCustomerCampaignPlatformApiSlice'
import { AnalyticsApi } from './redux/Api/AnalyticsApiSlice'
import { CustomerApi } from './redux/Api/CustomerApiSlice'
import { PlatformApi } from './redux/Api/PlatformApiSlice'
import { UtilsApi } from './redux/Api/UtilsApiSlice'
import { VideoApi } from './redux/Api/VideoApiSlice'
import { WhitelistApi } from './redux/Api/WhitelistApiSlice'
import { GuacamoleApi } from './redux/Api/GuacamoleManagment/GuacamoleApiSlice'

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware().concat(
            uMUserApi.middleware,
            uMUsersApi.middleware,
            uMGroupPermissionsApi.middleware,
            uMGroupsApi.middleware,
            uMPermissionsApi.middleware,
            uMUserGroupsApi.middleware,
            uMUserPermissionsApi.middleware,
            uMUsersContentTypesApi.middleware,
            cMCampaignsApi.middleware,
            cMLanguagesApi.middleware,
            cMLoaApi.middleware,
            cMPlatformsApi.middleware,
            cMTypesApi.middleware,
            customerCampaignPlatformApi.middleware,
            AnalyticsApi.middleware,
            CustomerApi.middleware,
            PlatformApi.middleware,
            UtilsApi.middleware,
            VideoApi.middleware,
            WhitelistApi.middleware,
            GuacamoleApi.middleware,
        ),
})

